function ContactHelpPage() {
  return (
    <div
      className='d-flex flex-column shadow bordered rounded p-3'
      style={{ minHeight: '300px' }}
    >
      <h2 className='mb-2'>Контакты</h2>
      <div>
        <i className='bi-envelope-fill'></i> <b>Почта: </b>
        pevloks@gmail.com
      </div>
    </div>
  );
}

export default ContactHelpPage;
